// extracted by mini-css-extract-plugin
module.exports = {"base":"Gears_base__eLQPk"};